<div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">

  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Image Upscaler</h2>


  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">
      <form #enhanceImageForm="ngForm">
        <div class="upload-box" (click)="fileUploadRef.click()" (drop)="onDrop($event)" (dragover)="allowDrop($event)" (dragenter)="allowDrop($event)">
          <span>
            <img src="../../../../../../../assets/theme/images/icons/photo-plus.svg"  alt="photo-plus"
            class="w-6 h-6 cursor-pointer" />
          </span>
          <p>
            Click to Add or Drag & Drop Images</p>

          <input type="file" id="fileUpload" (change)="onSelect($event)" [accept]="allowedExtensions.join(',')"
            required ngModel #fileInput="ngModel"  class="hidden"
            name="fileUpload" id="fileUpload" #fileUploadRef />
          <!-- <label for="fileUpload">Choose File</label> -->
        </div>
        @if (imageUpScalarRequestModel.file) {
        <div class="file-info cursor-pointer" (click)="clear()">
          <span class="file-name">{{ imageUpScalarRequestModel.file.name }}</span>
          <span class="clear-button">✖</span>
        </div>
        }
        @if(fileError){
        <div class="text-red-500 text-sm mt-2">{{this.fileError}}</div>
        }
      </form>
    </div>
  </div>

  <div class="mx-auto">



    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 w-full lg:w-[800px] max-w-full mx-auto">

      <div class="w-full lg:w-auto lg:flex-1 lg:min-w-0 min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <ul class="flex flex-nowrap items-center text-nowrap cursor-pointer mb-2 list-none p-0 m-0 overflow-x-auto">
          <li class="nav-item">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Original'}"
                  (click)="setTab('Original')">
                  See Original
              </a>
          </li>
          <li class="nav-item ms-2">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'UpScaled-image'}" (click)="setTab('UpScaled-image')">
                  Upscaled Image
              </a>
          </li>
          @if (imageUpScalarRequestModel.file) {
            <div class="ms-auto mt-2">
              <span>
                <img (click)="clear()" src="../../../../../../../assets/images/reset.svg" title="reset" alt="reset" height="18" width="18"
                  class="w-6 h-6 cursor-pointer" />
              </span>
            </div>
          }
      </ul>


        @if(!imageUpScalarRequestModel.file){
        <div class="image-preview">
          <p>No image uploaded yet</p>
        </div>
        }
        @else {
          @if(activeTab === 'Original'){
            <div class="image-preview">
              <img [src]="this.imageUrl" alt="Uploaded" />
            </div>
          }
          @else {
            @if(isLoading){
              <div class="rounded-2xl">
                <div class="h-[400px] w-full bg-gray-400 rounded animate-pulse"></div>
              </div>
              }
             @else if(imageUpScalarResponeModel.base64_image){
               <div class="image-preview">
                 <img [src]="getImageSource" alt="Removed Background" />
               </div>
             }
          }
        }


      </div>

      <div class="w-full lg:w-80 shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
      <h2 class="text-base sm:text-lg text-gray-600 text-center font-medium mb-4">Click here to download</h2>

        <button type="submit" (click)="downloadImage()" [disabled]="!this.imageUpScalarResponeModel.base64_image"
          class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
           text-white font-medium bg-black">
           Download Image
          @if(isDownloading){
          <span
            class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
          }
        </button>
      </div>
    </div>

  </div>


</div>
